<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-dollar-sign</v-icon>
        <span class="m-l-5">Variable</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>
    <div class="container">
      <div class="box-type">
        <v-radio-group v-model="prompt.contentType" row hide-details>
          <v-radio
            v-for="(type, indexType) in contentTypes"
            :key="indexType"
            :label="type"
            :value="type"
          >
          </v-radio>
        </v-radio-group>
      </div>
      <div>
        <v-text-field
          class="min-width-55 top-5 no-drag p-b-0"
          v-model="prompt.name"
          placeholder="Variable"
          hint="For example, ${api.data.*}"
          dense
        >
        </v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayloadParameter',
  props: {
    index: Number,
    prompt: Object
  },
  data() {
    return {
      contentTypes: ['Text', 'Image'],
      formats: ['dd-MM-yyyy', 'd-M-yyyy', 'dd/MM/yyyy', 'd/M/yyyy']
    }
  },
  methods: {
    changeSayAs() {
      if (this.prompt.say_as === 'DATE_LONG_BE')
        this.prompt.format = this.prompt.format || 'dd-MM-yyyy'
    },
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.min-width-55 {
  min-width: 55%;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}

.container {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.box-type {
  margin-bottom: 10px;
}
</style>
